var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerificationUploadIdSessionExpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 38.25,
    r: 38.25,
    fill: "#EBF3FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8216 15.2957L71.1418 66.4083C72.4625 68.792 71.5977 71.7933 69.2103 73.1119C68.4783 73.5162 67.6554 73.7283 66.8189 73.7283H10.1785C7.4501 73.7283 5.23828 71.52 5.23828 68.7959C5.23828 67.9607 5.45071 67.1392 5.85564 66.4083L34.1758 15.2957C35.4965 12.9121 38.5026 12.0487 40.8901 13.3673C41.7026 13.8161 42.3721 14.4844 42.8216 15.2957ZM37.1133 34.9239C36.3479 34.9239 35.7274 35.5444 35.7274 36.3098V52.9402C35.7274 53.7056 36.3479 54.3261 37.1133 54.3261H39.885C40.6504 54.3261 41.2709 53.7056 41.2709 52.9402V36.3098C41.2709 35.5444 40.6504 34.9239 39.885 34.9239H37.1133ZM37.1133 59.8696C36.3479 59.8696 35.7274 60.49 35.7274 61.2554V64.0272C35.7274 64.7926 36.3479 65.413 37.1133 65.413H39.885C40.6504 65.413 41.2709 64.7926 41.2709 64.0272V61.2554C41.2709 60.49 40.6504 59.8696 39.885 59.8696H37.1133Z",
    fill: "#9E007E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationUploadIdSessionExpired);
export default __webpack_public_path__ + "static/media/verification--uploadId__sessionExpired.5114c752609bc2568504a1c2d1bf6840.svg";
export { ForwardRef as ReactComponent };